import { render, staticRenderFns } from "./AppointmentRestrictionsBanner.vue?vue&type=template&id=840b488a&"
import script from "./AppointmentRestrictionsBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AppointmentRestrictionsBanner.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('840b488a')) {
      api.createRecord('840b488a', component.options)
    } else {
      api.reload('840b488a', component.options)
    }
    module.hot.accept("./AppointmentRestrictionsBanner.vue?vue&type=template&id=840b488a&", function () {
      api.rerender('840b488a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentRestrictionsBanner/AppointmentRestrictionsBanner.vue"
export default component.exports